module.exports = function () {
    $(window).on("load", function () {
        var fbqPixelPID = $(".pixel-add-to-cart").data("pixel-add-to-cart-pid");
        if (!fbqPixelPID) {
            fbqPixelPID = $(".product-detail").data("pid");
        }

        var viewContentObj = {
            content_type: "product_group",
            content_ids: [fbqPixelPID]
        };
        $("body").trigger("pixel:trackEvent", {
            event: "ViewContent",
            data: viewContentObj
        });
    });

    $("body").on("pixel:updateAddToCartSku", function (event, data) {
        var $pixelAddToCart = $(".pixel-add-to-cart");
        if (data && data.product && $pixelAddToCart) {
            if (data.product.masterID) {
                $pixelAddToCart.data("pixel-add-to-cart-pid", data.product.masterID);
            } else {
                $pixelAddToCart.data("pixel-add-to-cart-pid", data.product.id);
            }
        }
        if (data && data.products && data.products.length && $pixelAddToCart) {
            var product = data.products[0];
            if (product && product.masterID) {
                $pixelAddToCart.data("pixel-add-to-cart-pid", product.masterID);
            } else if (product) {
                $pixelAddToCart.data("pixel-add-to-cart-pid", product.id);
            }
        }
        if (data && data.bundleProduct && data.bundleProduct.driveCommerceMasterProductId && $pixelAddToCart) {
            $pixelAddToCart.data("pixel-add-to-cart-pid", data.bundleProduct.driveCommerceMasterProductId);
        }
    });
};
